import buildApplicabilityText from './buildApplicabilityText'
import createCategoryDescriptionItem from './createCategoryDescriptionItem'
import disputeAnalysisEnabled from './disputeAnalysisEnabled'
import formatEvidenceReference from './formatEvidenceReference'
import getAlternativeName from './getAlternativeName'
import getLoadingMessage from './getLoadingMessage'
import recommendedAlternative from './recommendedAlternative'
import truncateFilename from './truncateFilename'
import uploadDisputeAttachments from './uploadDisputeAttachments'

const dai = {
  buildApplicabilityText,
  createCategoryDescriptionItem,
  disputeAnalysisEnabled,
  formatEvidenceReference,
  getAlternativeName,
  getLoadingMessage,
  recommendedAlternative,
  truncateFilename,
  uploadDisputeAttachments,
}

export default dai
